import { render, staticRenderFns } from "./ockto-form.vue?vue&type=template&id=0c4c8dba"
import script from "./ockto-form.vue?vue&type=script&lang=ts"
export * from "./ockto-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports